import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface KmsVehicles {
    startKms: number,
    endKms: number,
    inEmpty: boolean
}

export interface Services {
    serviceId: number,
    pax: number,
    isClean: boolean,
    startDateTime: string,
    endDateTime: string,
    kmsVehicle: KmsVehicles[], 
}

export interface TimeSheetApprovalServicesPageState {
  services: Services[]
}

const initialState: TimeSheetApprovalServicesPageState = {
    services:[
        {
            serviceId: 0,
            pax: 0,
            isClean: false,
            startDateTime: "",
            endDateTime: "",
            kmsVehicle: [
                {
                    startKms: 0,
                    endKms: 0,
                    inEmpty: false
                }
            ], 
        }
    ]
}

export const timesheetApprovalServicesSlice = createSlice({
    name: 'timesheetApprovalServices',
    initialState,
    reducers: {
      handleServices: (state, action: PayloadAction<TimeSheetApprovalServicesPageState>) => {
        state.services = action.payload.services
      }
    }
});

export const { handleServices } = timesheetApprovalServicesSlice.actions